import { useQuery } from "react-query";
import { dashboardSchema } from "modules/monitoring/ProbeList/schemas/formSchemas";
import { ENDPOINTS } from "modules/shared/webservices/constants/endpoints";
import { simpleRequest } from "core/services/api";
import { GLOBAL_FILTER } from "../constants";

export function getMetrics() {
  return async () => {
    const rawdata = await simpleRequest(ENDPOINTS.DASHBOARDS, dashboardSchema);
    const metricsdata = rawdata.filter(
      (dashboard) => dashboard.category_name === "MEASURE"
    );
    const data = dashboardSchema.parse(metricsdata);

    return data;
  };
}

export function useMetrics(fetch = true, selectedRegions: string[]) {
  return useQuery(["metrics"], getMetrics(), {
    enabled: fetch,
    select: (data) => {
      return (
        data[0]?.probes &&
        Object.values(data[0]?.probes)
          .filter((probe) => {
            if (!probe) return true;
            if (selectedRegions.length > 0) {
              const isGlobalProbe =
                selectedRegions.includes(GLOBAL_FILTER) && probe.region == null;
              return (
                isGlobalProbe ||
                selectedRegions.includes(probe.region as string)
              );
            }
            return true;
          })
          .sort((probA, probB) => {
            const titleA = probA.title?.toLowerCase();
            const titleB = probB.title?.toLowerCase();
            return titleA.localeCompare(titleB);
          })
      );
    },
  });
}
